
<template>
  <router-view />
</template>

<script>
export default {
  name: "app-blacklist"
};
</script>

<style lang="scss" scoped></style>
